/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  moduleWrap: {
    display: "flex",
    flexDirection: "row",
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  hide: {
    display: 'none',
  },
  loader: {
    textAlign: "center",
    alignItems: "center",
    padding: theme.spacing(1.5),
  },
  topLeftHeaderContainer: {
    display: "flex",
    color: theme.palette.text.secondary,
    backgroundColor: "#F6F7FA",
    borderRight: ".5px solid #E0E0E0",
    height: theme.spacing(6),
    width: theme.spacing(40),
  },
  topRightHeaderContainer: {
    display: "flex",
    alignItems: "center",
    textAlign: "right",
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
  },
  listItemPaper: {
    textAlign: "left",
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
    overflowY: "auto",
    marginRight: theme.spacing(0.125),
    // borderRight: ".5px solid #E0E0E0",
  },
  searchListContainer: {
    border: "1px solid #e0e0e0",
  },
  ListItemContent: {
    display: "flex",
    justifyContent: "space-between",
  },
  secondaryAction: {
    right: 0,
  },
  listItemRow: {
    display: "flex",
    flexDirection: "row",
  },
  rightContainer: {
    flex: 1,
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
  },
  threeDotBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  menuIconStyle: {
    minWidth: theme.spacing(5),
  },
  textEllipsisSecondary: {
    whiteSpace: 'nowrap',
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: theme.spacing(25)
  },
  emptyScreenRoot: {
    flexGrow: 1,
    marginTop: theme.spacing(0.375),
    backgroundColor: theme.palette.background.paper,
    borderTopLeftRadius: theme.spacing(0.75),
    borderTopRightRadius: theme.spacing(0.75),
  },
}));
